import './style.css';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../shared/components/alert/Alert';
import { Button } from '../shared/components/button/Button';
import LoadingSpinner from '../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../shared/hooks/http-hook';
import { handleEmailChange } from '../shared/util/handleValueChange';
import { RightPanelContainer } from './layout/RightPanelContainer';

export function RequestAccessCode() {
  const { isLoading, error, sendRequest } = useHttpClient();
  const { t } = useTranslation();

  const [email, setEmail] = useState<string | undefined>();
  const [emailError, setEmailError] = useState(false);
  const [message, setMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const resetHandler = async (event) => {
    setShowError(true);
    if (!email?.trim()) {
      setEmailError(true);
      return;
    }
    if (emailError) return;
    event.preventDefault();
    setMessage('');

    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/users/forgottenCode`,
        'POST',
        JSON.stringify({
          email,
        })
      );
      if (responseData.message) {
        setMessage(responseData.message);
      }
    } catch (err) {
      /* empty */
    }
  };

  const handleEmailInputChange = (e) => {
    setShowError(false);
    handleEmailChange(e, setEmail, setEmailError);
  };

  return (
    <RightPanelContainer type="requestAccessCode">
      <form>
        <h1>{t('R073')}</h1>
        <p>{t('R074')}</p>
        <label className="not_logged_label" htmlFor="email">
          {showError && t('error.prefix')} {t('R023')}
        </label>
        <input
          type="email"
          className="code_input "
          id="email"
          name="email"
          aria-label={t('R023')}
          onChange={(e) => handleEmailInputChange(e)}
        />
        {showError && emailError && (
          <Alert
            isVisible
            isAssessive
            message={t('signin.email.error')}
            type="error"
            id="login_error"
          />
        )}
        {isLoading && <LoadingSpinner />}
        {message?.length > 0 && (
          <Alert
            isVisible
            isAssessive
            message={message || error}
            type="success"
            id="login_success"
          />
        )}
        {showError && error?.length > 0 && (
          <Alert isVisible isAssessive message={message || error} type="error" id="login_error" />
        )}
        {!isLoading && (
          <Button onClick={resetHandler} id="continue">
            {t('R079')}
          </Button>
        )}
      </form>
    </RightPanelContainer>
  );
}
